// extracted by mini-css-extract-plugin
export var container = "_4g-0";
export var icon = "_4g-1";
export var text = "_4g-2";